<script>
import appConfig from "@/app.config";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { registrar, ACCIONES } from "@/services/bitacora";
import { empleadoComputed } from "@/state/helpers";

export default {
  page: {
    title: "Negocios",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    //DatePicker,
  },
  computed: {
    ...empleadoComputed,
  },
  methods: {
    GuardarEmpleado() {
      const datos = {
        nombre: this.nombre,
        telefono: this.telefono,
        email: this.email.toLowerCase(),
        // El rol decide qué puede hacer dentro del panel: "admin" edita,
        // "lector" sólo consulta.
        rol: this.rolNuevo,
        register_date: moment().format("DD-MM-YYYY"),
        register_by: firebase.auth().currentUser.email
      };
      firebase
        .firestore()
        .collection("empleados")
        .doc(this.email.toLowerCase())
        .set(datos)
        .then(() => registrar({
          accion: ACCIONES.CREAR,
          coleccion: "empleados",
          docId: datos.email,
          descripcion: `${datos.nombre} (${datos.rol})`,
          despues: datos,
        }))
        .then(() => {
          location.href = "/usuarios/index/";
        })
        .catch((error) => {
          alert(error);
        });
      Swal.fire({
        icon: "success",
        title: "Tu registro ha sido guardado",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    deleteEmpleado(email) {
      Swal.fire({
        title: "¿Estas seguro de eliminar esta empresa?",
        text: "Este producto se eliminiara permanentemente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Borrar",
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            "Eliminado",
            "Su producto ha sido eliminado con exito",
            "success"
          );
          const antes = this.dataEmpleado.find((e) => e.email === email);
          firebase
            .firestore()
            .collection("empleados")
            .doc(email.toString())
            .delete()
            .then(() => registrar({
              accion: ACCIONES.ELIMINAR,
              coleccion: "empleados",
              docId: String(email),
              descripcion: antes ? antes.nombre : String(email),
              antes,
            }))
            .then(() => {
              location.href = "/usuarios/index/";
            })
            .catch((error) => {
              alert("Error removing document: ", error);
            });
        }
      });
    },
  },
  mounted() {
    firebase
      .firestore()
      .collection("empleados")
      .get()
      .then((querySnapshot) => {
        console.log("🚀 ~ file: contenidoUsuarios.vue ~ line 80 ~ .then ~ querySnapshot", querySnapshot)
        var array = [];
        querySnapshot.forEach((documentSnapshot) => {
          array.push(documentSnapshot.data());
        });
        this.dataEmpleado = array;
      });
  },
  data() {
    return {
      title: "Negocios",
      items: [
        {
          text: "Negocios",
          href: "/",
        },
        {
          text: "General",
          active: true,
        },
      ],
      img: null,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 3.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      nombre: null,
      telefono: null,
      horario: null,
      rfc: null,
      fechaNacimiento: null,
      email: null,
      agregarEmpleado: false,
      numTelefono: null,
      options: [],
      dataEmpleado: [],
      rolNuevo: "admin",
    };
  },
};
</script>
<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <div class="clearfix mt-4 mt-lg-0">
              <div class="col-sm-12">
                <div class="text-sm-right mt-2 mt-sm-0">
                  <button v-if="puedeEditar" @click="agregarEmpleado = true" type="button" class="btn btn-success">
                    Nuevo Empleado
                  </button>
                </div>
                <br />
              </div>
            </div>
            <table class="table table-centered mb-0 table-nowrap">
              <thead class="thead-light">
                <tr>
                  <!-- <th>RFC</th> -->
                  <th>Nombre</th>
                  <th>Telefono</th>
                  <th>Email</th>
                  <th>Rol</th>
                  <th>Fecha de Registro</th>
                  <th>Registrado por</th>
                  <!-- <th>Fecha Nacimiento</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in dataEmpleado" :key="data.email">
                  <td>{{ data.nombre }}</td>
                  <td>{{ data.telefono }}</td>
                  <td>{{ data.email }}</td>
                  <td>
                    <!-- Los empleados creados antes de existir el campo no traen
                         rol; el sistema los trata como administradores. -->
                    <b-badge :variant="(data.rol || 'admin') === 'admin' ? 'primary' : 'secondary'">
                      {{ (data.rol || 'admin') === 'admin' ? 'Administrador' : 'Lector' }}
                    </b-badge>
                  </td>
                  <td>{{ data.register_date }}</td>
                  <td>{{ data.register_by }}</td>
                  <td>
                    <button v-if="puedeEditar" type="button" class="btn btn-danger"
                      @click="deleteEmpleado(data.email)">
                      Eliminar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- end row-->
        </div>
      </div>
    </div>
    <!--INICIO MODAL NUEVA EMPRESA-->
    <b-modal v-model="agregarEmpleado" id="edit" size="lg" title="Nuevo usuario" centered>
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <label class="mb-1 font-weight-medium">
              <b>Datos Personales</b>
            </label>
            <div class="form-group">
              <div class="row">
                <!-- <div class="col-sm-6">
                  <label class="control-label">RFC</label>
                  <input
                    v-model="rfc"
                    type="text"
                    class="form-control"
                  />
                </div> -->
                <div class="col-sm-6">
                  <label class="control-label">Nombre del empleado.</label>
                  <input v-model="nombre" type="text" class="form-control" />
                </div>
                <div class="col-sm-6">
                  <label class="control-label">Correo Electronico</label>
                  <input v-model="email" type="text" class="form-control" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-6">
                  <label class="control-label">Telefono.</label>
                  <input v-model="telefono" type="text" class="form-control" />
                </div>
                <div class="col-sm-6">
                  <label class="control-label">Rol</label>
                  <b-form-select v-model="rolNuevo" :options="[
                    { value: 'admin', text: 'Administrador (puede editar y borrar)' },
                    { value: 'lector', text: 'Lector (sólo consulta)' },
                  ]" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <template v-slot:modal-footer>
        <button @click="GuardarEmpleado" type="button" class="btn btn-success">
          Guardar
        </button>
        <b-button variant="secondary" @click="agregarEmpleado = false">Cerrar</b-button>
      </template>
    </b-modal>
    <!--FIN MODAL NUEVA EMPRESA-->
  </div>
</template>